import styled from '@emotion/styled';

export const Tags = styled.div`
  margin: 30px 0 30px 0;
  padding: 0.3rem 0;
  text-align: center;
  background: ${({ theme }) => theme.colors.secondary.white};
  box-shadow: ${({ theme }) => theme.boxShadow};
`;

export const ContentBoxWrapper = styled.div`
  position: absolute;
  top: 10%;
  bottom: 500px;
  height: calc(90% - 500px);
  left: calc(50vw + 600px);
`;

export const ContentBoxContainer = styled.div`
  top: 200px;
  position: sticky;
  display: none;
  ${({ theme }) => theme.breakpoints.xl} {
    display: block;
  }
`;

export const StyledTextBlock = styled.div`
  height: 290px;
  width: 220px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const NotStickyContentBox = styled.div`
  display: block;
  ${({ theme }) => theme.breakpoints.xl} {
    display: none;
    max-width: 0;
    max-height: 0;
  }
`;
